import { useQuery } from "@tanstack/react-query";
import { getUsers, getUsersByRole } from "./users.service";

const key = "jeep-rally-users";

export const useGetUsers = (params = {}, options = {}) => {
  return useQuery({
    queryKey: [key, params],
    queryFn: () => getUsers(params),
    ...options,
  });
};

export const useGetUsersByRole = (role, options = {}) => {
  return useQuery({
    queryKey: [key, "role", role],
    queryFn: () => getUsersByRole(role),
    enabled: Boolean(role) && options.enabled !== false,
    ...options,
  });
};
